const billingToVariantMapping = {
	'zkOmJtn5': 'cz',
	'VhVtMc7n': 'cz',
	'JORtMBBl': 'cz',
	'6yya2CGx': 'cz',
	'abx-E3NY': 'cz',
	'abx-awM7': 'cz',
	'ebxSdgW3': 'cz',
	'abx-Qa1t': 'cz',
	'zw9eZpk8': 'cz',
	'tXhcR23B': 'cz',
	'TBaXENI3': 'cz',
	'abx-ZhNl': 'cz',
};

module.exports = billingToVariantMapping;



// WEBPACK FOOTER //
// ./js/billingToVariantMapping.js